exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntr[data-v-7abd0d4e]:hover {\n    background-color: transparent !important;\n}\n\n", ""]);
